// src/features/subscription/subscriptionSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPlans,
  fetchMySubscription,
  purchaseSubscription,
} from "./subscriptionThunks";

const initialState = {
  plans: [],
  loadingPlans: false,
  plansError: null,

  mySubscription: null,
  loadingMySubscription: false,
  mySubscriptionError: null,

  buying: false,
  buyError: null,
  lastPurchaseMessage: null,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    clearSubscriptionState(state) {
      state.buyError = null;
      state.lastPurchaseMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH PLANS
      .addCase(fetchPlans.pending, (state) => {
        state.loadingPlans = true;
        state.plansError = null;
      })
      .addCase(fetchPlans.fulfilled, (state, action) => {
        state.loadingPlans = false;
        state.plansError = null;
        state.plans = action.payload?.data || [];
      })
      .addCase(fetchPlans.rejected, (state, action) => {
        state.loadingPlans = false;
        state.plansError = action.payload || action.error?.message;
      })

      // FETCH MY SUBSCRIPTION
      .addCase(fetchMySubscription.pending, (state) => {
        state.loadingMySubscription = true;
        state.mySubscriptionError = null;
      })
      .addCase(fetchMySubscription.fulfilled, (state, action) => {
        state.loadingMySubscription = false;
        state.mySubscriptionError = null;
        state.mySubscription = action.payload?.data || null;
      })
      .addCase(fetchMySubscription.rejected, (state, action) => {
        state.loadingMySubscription = false;
        state.mySubscriptionError = action.payload || action.error?.message;
      })

      // PURCHASE
      .addCase(purchaseSubscription.pending, (state) => {
        state.buying = true;
        state.buyError = null;
        state.lastPurchaseMessage = null;
      })
      .addCase(purchaseSubscription.fulfilled, (state, action) => {
        state.buying = false;
        state.buyError = null;
        state.lastPurchaseMessage =
          action.payload?.message || "Subscription purchased successfully";

        // update mySubscription if backend returns fresh subscription in data
        if (action.payload?.data) {
          state.mySubscription = action.payload.data;
        }
      })
      .addCase(purchaseSubscription.rejected, (state, action) => {
        state.buying = false;
        state.buyError = action.payload || action.error?.message;
      });
  },
});

export const { clearSubscriptionState } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
